import { EmotionCacheProvider, theme, ThemeProvider } from '@ori-ui/mui';
import { defaultTranslations as addressFormDefaultTranslations, translationsNamespace as addressFormTranslationsNamespace } from '@ori/address-form';
import { UniversalTokenProvider } from '@ori/auth';
import { parseClientAppConfig } from '@ori/client-app-config';
import { defaultTranslations as fieldDefaultTranslations, translationsNamespace as fieldTranslationsNamespace } from '@ori/common-form-fields';
import { ServiceUrlsProvider } from '@ori/configuration-manager';
import { ClientCultureProvider } from '@ori/culture';
import { EnvironmentProvider } from '@ori/environment';
import { TranslationsProvider } from '@ori/i18n';
import { defaultTranslations, SimplifiedRegistration, translationsNamespace, simplifiedRegistrationVIPCustomerDefaultTranslations, simplifiedRegistrationVIPCustomerTranslationNamespace } from '@ori/simplified-registration';
import { ApiClientProvider as StaticApiClientProvider } from '@ori/static-api-client-react';
import { createRoot } from 'react-dom/client';
import { EMOTION_CACHE_KEY } from './constants-generated';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * React app renderer that is used when app is used as a standalone app
 */
export async function render(rootElement) {
  const {
    config = ''
  } = rootElement.dataset;
  const clientAppConfig = parseClientAppConfig(config, ['currentLanguage', 'globalApiUrl', 'staticApiUrl', 'tenant']);
  const {
    customerId,
    globalApiUrl,
    staticApiUrl,
    identityUrl,
    graphqlNetUrl,
    graphqlUrl,
    tenant,
    currentLanguage,
    registrationType
  } = clientAppConfig;
  const correctTranslationNameSpace = registrationType === 'Consultant' ? translationsNamespace : simplifiedRegistrationVIPCustomerTranslationNamespace;
  const correctDefalutTranslations = registrationType === 'Consultant' ? defaultTranslations : simplifiedRegistrationVIPCustomerDefaultTranslations;
  const translationProps = {
    clientFetchConfiguration: {
      baseUrl: staticApiUrl,
      onError: error => {
        console.log('Error occured while loading translations.', String(error));
      },
      tenant
    },
    currentLanguage,
    defaultTranslationsWithNamespaces: {
      [correctTranslationNameSpace]: correctDefalutTranslations,
      [fieldTranslationsNamespace]: fieldDefaultTranslations,
      [addressFormTranslationsNamespace]: addressFormDefaultTranslations
    }
  };
  createRoot(rootElement).render(/*#__PURE__*/_jsx(ServiceUrlsProvider, {
    serviceUrls: {
      graphQlUrl: graphqlUrl,
      graphQlNetUrl: graphqlNetUrl,
      globalApiUrl,
      staticApiUrl,
      identityUrl
    },
    children: /*#__PURE__*/_jsx(EnvironmentProvider, {
      tenant: tenant,
      children: /*#__PURE__*/_jsx(UniversalTokenProvider, {
        customerId: customerId,
        initialToken: "",
        children: /*#__PURE__*/_jsx(StaticApiClientProvider, {
          baseUrl: staticApiUrl,
          tenant: tenant,
          language: currentLanguage,
          camelcaseKeysOptions: {
            exclude: [/^[a-z]{2}-[A-Z]{2}$/, 'TermsAndConditions_Url', 'PrivacyPolicy_Url', 'LegalDocument1_Link', 'LegalDocument2_Link', 'LegalDocument3_Link', 'LegalDocument4_Link', 'LegalDocument5_Link', 'LegalDocument6_Link', 'LegalDocument7_Link', 'LegalDocument8_Link']
          },
          children: /*#__PURE__*/_jsx(ClientCultureProvider, {
            tenant: tenant,
            children: /*#__PURE__*/_jsx(ThemeProvider, {
              theme: theme,
              children: /*#__PURE__*/_jsx(EmotionCacheProvider, {
                cacheKey: EMOTION_CACHE_KEY,
                children: /*#__PURE__*/_jsx(TranslationsProvider, {
                  ...translationProps,
                  children: /*#__PURE__*/_jsx(SimplifiedRegistration, {
                    registrationType: registrationType
                  })
                })
              })
            })
          })
        })
      })
    })
  }));
}